import {
  User,
  BookOpen,
  GraduationCap,
  Users,
  CreditCard,
  IndianRupee,
  BadgePercent,
  VideoIcon,
  FileText,
  UserStar,
  Wallet,
} from "lucide-react";
import { ROUTES } from "../routes/routePaths";

export const sampleStudentsData = [
  {
    name: "Ram",
    email: "ram@gmail.com",
    course: "React",
    status: "Active",
    contact: "8770804298",
  },
  {
    name: "Aman",
    email: "aman@gmail.com",
    course: "Node",
    status: "Inactive",
    contact: "8109430525",
  },
];

export const dashboardNavTileData = [
  // Learning
  {
    id: "faculty",
    icon: <User />,
    title: "Faculty",
    desc: "Manage instructors and faculty members",
    href: ROUTES.DASHBOARD_FACULTY_MANAGEMENT,
  },
  {
    id: "course-content",
    icon: <BookOpen />,
    title: "Course Content",
    desc: "Manage course syllabi and content",
    href: ROUTES.DASHBOARD_COURSE_CONTENT_MANAGEMENT,
  },
  {
    id: "courses",
    icon: <GraduationCap />,
    title: "Courses",
    desc: "Create and manage courses",
    href: ROUTES.DASHBOARD_COURSE_MANAGEMENT,
  },
  {
    id: "batches",
    icon: <GraduationCap />,
    title: "Batches",
    desc: "Manage batches and schedules",
    href: ROUTES.DASHBOARD_BATCH_MANAGEMENT,
  },
  {
    id: "webinars",
    icon: <VideoIcon />,
    title: "Webinars",
    desc: "Create and manage webinars",
    href: ROUTES.DASHBOARD_WEBINAR_MANAGEMENT,
  },
  {
    id: "webinar-registrations",
    icon: <Users />,
    title: "Webinar Registrations",
    desc: "View webinar registrations",
    href: ROUTES.DASHBOARD_WEBINAR_REGISTRATIONS,
  },
  {
    id: "lectures",
    icon: <VideoIcon />,
    title: "Lectures",
    desc: "Upload and manage lecture videos",
    href: ROUTES.DASHBOARD_LECTURE_MANAGEMENT,
  },
  {
    id: "blogs",
    icon: <FileText />,
    title: "Blogs",
    desc: "Create and manage blog posts",
    href: ROUTES.DASHBOARD_BLOG_MANAGEMENT,
  },
  {
    id: "students",
    icon: <Users />,
    title: "Students",
    desc: "Manage student enrollments",
    href: ROUTES.DASHBOARD_STUDENT_MANAGEMENT,
  },
  {
    id: "subscriptions",
    icon: <CreditCard />,
    title: "Subscriptions",
    desc: "Manage subscription plans",
    href: ROUTES.DASHBOARD_SUBSCRIPTION_MANAGEMENT,
  },
  // Finance
  {
    id: "fees",
    icon: <IndianRupee />,
    title: "Fees",
    desc: "Manage fees and payments",
    href: ROUTES.DASHBOARD_FEES_MANAGEMENT,
  },
  {
    id: "offers",
    icon: <BadgePercent />,
    title: "Offers",
    desc: "Manage discounts and offers",
    href: ROUTES.DASHBOARD_OFFER_MANAGEMENT,
  },
  {
    id: "reviews",
    icon: <UserStar />,
    title: "Review Management",
    desc: "Manage or post new reviews",
    href: ROUTES.DASHBOARD_REVIEWS_MANAGEMENT,
  },
];
